import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Rule, ValidationRules } from 'aurelia-validation';
import { DeviationRequestBase } from 'model/forms/deviation-request';

@customElement('deviation-request-info-panel')
export class DeviationRequestInfoPanelCustomElement {
  @bindable model: DeviationRequestBase;
  @bindable disabled: boolean;
  infoPanelRules: Rule<DeviationRequestBase, any>[][];

  modelChanged() {
    this.infoPanelRules = ValidationRules
      .ensureObject<DeviationRequestBase>().required()
      .ensure(model => model.reason).displayName('Reason for Deviation').required()
      .ensure(model => model.alternativeOptions).displayName('Alternative Options').required()
      .ensure(model => model.riskManagement).displayName('Deviation Risk Management').required()
      .rules;
  }
}
